import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { getProjectDetailsQueryKey } from '@/features/projects/shared/hooks/use-project-details';
import { assignAddon } from '@/features/subscriptions/api/assign-addon';
import { ADDON_SUBSCRIPTIONS_QUERY_KEY } from '@/features/subscriptions/hooks/use-addon-subscriptions';
import { PROJECT_ENTITLEMENTS_QUERY_KEY } from '@/features/subscriptions/hooks/use-project-entitlements';
import { useToast } from '@/shared/hooks/use-toast';
import { useErrorTranslation } from '@/shared/utils/error-handling';

export function useAssignAddon() {
  const queryClient = useQueryClient();
  const { toast } = useToast();
  const errorTranslation = useErrorTranslation();
  const { t } = useTranslation('subscriptions');

  return useMutation({
    mutationFn: assignAddon,
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: [ADDON_SUBSCRIPTIONS_QUERY_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: getProjectDetailsQueryKey(String(variables.projectId)),
      });
      queryClient.invalidateQueries({
        queryKey: [PROJECT_ENTITLEMENTS_QUERY_KEY],
      });
      toast({
        title: t('projectPlans.addonAssignmentSuccess'),
      });
    },
    onError: (error) => {
      toast({
        title: errorTranslation(error),
        variant: 'destructive',
      });
    },
  });
}
